<template>
    <g>
        <path
            d="M17.8418 4.75188C16.8317 4.32819 15.8207 4.16699 14.8103 4.16699C11.6028 4.16673 8.3956 5.7904 5.1881 5.7904C4.38368 5.7904 3.57979 5.68832 2.77537 5.43312C2.68501 5.40447 2.59439 5.39093 2.50585 5.39093C2.05768 5.39093 1.66602 5.7378 1.66602 6.2193V14.4812C1.66602 14.8101 1.85429 15.1218 2.15663 15.2483C3.16677 15.6723 4.1777 15.8335 5.1881 15.8335C8.3956 15.8335 11.6031 14.2098 14.8106 14.2098C15.615 14.2098 16.4189 14.3119 17.2233 14.5671C17.3137 14.5957 17.4043 14.6093 17.4929 14.6093C17.941 14.6093 18.3327 14.2624 18.3327 13.7809V5.51932C18.3324 5.19015 18.1441 4.8787 17.8418 4.75188ZM2.916 6.77685C3.43995 6.9081 3.98681 6.97398 4.5493 7.0094C4.39618 7.77475 3.72328 8.35156 2.916 8.35156V6.77685ZM2.916 14.1986V12.9544C3.81103 12.9544 4.53524 13.6645 4.57509 14.5533C3.98838 14.5062 3.43995 14.389 2.916 14.1986ZM9.99922 12.5002C8.84846 12.5002 7.91592 11.3807 7.91592 10.0002C7.91592 8.61953 8.84872 7.50027 9.99922 7.50027C11.1497 7.50027 12.0825 8.61953 12.0825 10.0002C12.0825 11.3812 11.1495 12.5002 9.99922 12.5002ZM17.0824 13.2236C16.6262 13.1093 16.1525 13.0452 15.6679 13.0038C15.8207 12.3247 16.384 11.8091 17.0824 11.7205V13.2236ZM17.0824 7.07502C16.278 6.9732 15.6538 6.30159 15.6291 5.47218C16.1379 5.52869 16.621 5.63442 17.0824 5.80186V7.07502Z"
            :fill="iconFill"
        />
    </g>
</template>
<script>
export default {
    name: "Uang2020",
    props: {
        iconFill: {
            type: String,
            default: "#206CFF",
        },
    },
};
</script>
